import { render, staticRenderFns } from "./HeaderButton.vue?vue&type=template&id=7891bfc2&scoped=true&"
import script from "./HeaderButton.vue?vue&type=script&lang=js&"
export * from "./HeaderButton.vue?vue&type=script&lang=js&"
import style0 from "./HeaderButton.vue?vue&type=style&index=0&id=7891bfc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7891bfc2",
  null
  
)

export default component.exports